
import Toast from 'vux/src/components/toast/index.vue'


export default {
name: "Cpts030",
components: {
Toast,
},
props: {
maxNum: Number,
maxSize: Number,
typeKind: String,
url: {
default: '/api/wtcp-complaints/attachements'
}
},
data() {
return {
toastShow: false,
toastText: "",
imgList: [],
limit: this.maxNum,
isUploading: false,
audioList: [],
};
},
methods: {

zipImg(file) {
return new Promise((resolve) => {
let that = this;
if (file && (file.size / 1024 > 500 || file.type !== "image/gif")) {
let img = new Image();
img.src = URL.createObjectURL(file);
let cvs = document.createElement("canvas");
let maxRatio = 0.15; 
let minRatio = 0.2; 
let imgQulity = 0.5; 
img.onload = async function () {
let ratio =
img.naturalWidth > 1000 || img.naturalHeight > 1000 ? maxRatio : minRatio;
cvs.width = img.naturalWidth * ratio;
cvs.height = img.naturalHeight * ratio;
let ctx = cvs.getContext("2d");
ctx.drawImage(img, 0, 0, cvs.width, cvs.height);

let zipBase64 = cvs.toDataURL(file.type, imgQulity);
let fileFixed = await that.dataURLtoFile(zipBase64, file.name, file.type);
resolve(fileFixed);
};
} else {
resolve(file);
}
});
},



dataURLtoFile(dataurl, filename, mime) {
return new Promise((resolve) => {
let arr = dataurl.split(";base64,");
let suffix = mime.split("/")[1];
let bstr = atob(arr[1]);
let n = bstr.length;
let u8arr = new Uint8Array(n);
while (n--) {
u8arr[n] = bstr.charCodeAt(n);
}
let data = new File([u8arr], `${filename}`, {
type: mime,
});
resolve(data);
});
},

showWin() {
this.toastText = "最多可上传" + this.maxNum + "张图片";
this.toastShow = true;
},
chooseType() {
document.getElementById("upload_file").click();
},
audiofileChange(el) {
if (!el.target.files[0].size) return;
for (let i = 0; i < el.target.files.length; i++) {
let value = el.target.files[i].size;
if (value > 1024000 * this.maxSize) {
this.toastText = "音频不能大于" + this.maxSize + "M";
this.toastShow = true;
return;
}
}
this.fileList(el.target);
el.target.value = "";
},
fileChange(el) {
if (!el.target.files[0].size) return;
for (let i = 0; i < el.target.files.length; i++) {
let value = el.target.files[i].size;
if (value > 1024000 * this.maxSize) {
this.toastText = "图片不能大于" + this.maxSize + "M";
this.toastShow = true;
return;
}
}
this.fileList(el.target);
el.target.value = "";
},
fileList(fileList) {
let files = fileList.files;
for (let i = 0; i < files.length; i++) {

if (files[i].type != "") {
this.fileAdd(files[i]);
} else {


this.folders(fileList.items[i]);
}
}
},
folders(files) {
let _this = this;

if (files.kind) {
files = files.webkitGetAsEntry();
}
files.createReader().readEntries(function (file) {
for (let i = 0; i < file.length; i++) {
if (file[i].isFile) {
_this.foldersAdd(file[i]);
} else {
_this.folders(file[i]);
}
}
});
},
foldersAdd(entry) {
let _this = this;
entry.file(function (file) {
_this.fileAdd(file);
});
},
fileAdd(file) {
if (this.limit !== undefined) this.limit--;
if (this.limit !== undefined && this.limit < 0) {
this.showWin();
return;
}
this.isUploading = true; 

const userInfo = localStorage.getItem("userInfo")
? JSON.parse(localStorage.getItem("userInfo"))
: "";

this.size = this.size + file.size;

if (this.$route.query.name === "theComplaint" && file.type.indexOf("image") == -1) {
this.toastText = "请选择图片文件";
this.toastShow = true;
} else if (this.$route.query.name === "voice" && file.type.indexOf("audio") == -1) {
this.toastText = "请选择音频文件";
this.toastShow = true;
} else {
const reader = new FileReader();
const readerAud = new FileReader();
if (this.$route.query.name === "theComplaint") {
let image = new Image();
let _this = this;
reader.readAsDataURL(file);
reader.onload = function () {
file.src = this.result;

const config = {
headers: {
"Content-Type": "multipart/form-data;boundary = " + new Date().getTime(),
},
};


const postData = {
base64Code: file.src,
format: file.type.split("/")[1],
};
_this.$http
.post(
"/api/zuul/wtcp-material/uploads/base64ToImg/toc/" + userInfo.user.id,
postData
)
.then((response) => {
if (response.data.status === 1) {
const array = new Array();
array.push(response.data.data);
array.forEach((item) => {
item.filePath = item.fileUrl.substring(32);
});
_this.$http
.post(_this.url + "?access_token=" + userInfo.access_token, array)
.then((response) => {
if (response.data.status === 1) {
image.onload = function () {
let width = image.width;
let height = image.height;
file.width = width;
file.height = height;

_this.imgList.push({
file,
});
};

image.src = file.src;
setTimeout(() => {
_this.isUploading = false;
}, 200);
_this.$emit("on-file-add", response.data.data);
} else {
_this.toastText = "图片保存失败";
_this.toastShow = true;
}
});
} else {
_this.toastText = "图片上传失败";
_this.toastShow = true;
}
});
};
}else{
const audiO = new FormData();
let _this = this;
readerAud.readAsDataURL(file);
readerAud.onload = function () {


const config = {
headers: {
"Content-Type": "multipart/form-data;boundary = " + new Date().getTime(),
},
};


const postData = {
base64Code: this.result,
format: file.name.split('.')[1],
};
_this.$http
.post(
"/api/zuul/wtcp-material/uploads/base64ToAudio/toc/" + userInfo.user.id,
postData
)
.then((response) => {

if (response.data.status === 1) {
const array = new Array();
array.push(response.data.data);
array.forEach((item) => {
item.filePath = item.fileUrl.substring(32);
});

_this.$http
.post(_this.url + "?access_token=" + userInfo.access_token, array)
.then((response) => {

if (response.data.status === 1) {








_this.audioList.push({
file,
});

setTimeout(() => {
_this.isUploading = false;
}, 200);
_this.$emit("on-file-add", response.data.data);
} else {

_this.toastText = "图片保存失败";
_this.toastShow = true;
}
});
} else {
_this.toastText = "图片上传失败";
_this.toastShow = true;
}
});
};
}
}
},
delImg(index) {
this.size = this.size - this.imgList[index].file.size; 
this.imgList.splice(index, 1);
if (this.limit !== undefined) this.limit = this.maxNum - this.imgList.length;

this.$emit("on-file-del", index);
},
delaudio(index){
this.audioList.splice(index, 1);
this.$emit("on-file-del", index);

},
},
};
